import Vue from "vue";
import Router from "vue-router";

import DashboardLayout from '../layout/DashboardLayout.vue'
// GeneralViews
import NotFound from '../pages/NotFoundPage.vue'

// Admin pages
import Overview from 'src/pages/Overview.vue'
import UserProfile from 'src/pages/UserProfile.vue'
import Accounts from 'src/pages/Accounts.vue'
import TableList from 'src/pages/TableList.vue'
import Notifications from 'src/pages/Notifications.vue'
import Login from 'src/pages/FirstPages/Login.vue'
import ChangePassword from 'src/pages/FirstPages/ChangePassword.vue'
import ForgotPassword from 'src/pages/FirstPages/ForgotPassword.vue'
import Building from 'src/pages/Building.vue'
import House from 'src/pages/House.vue'
import Tenant from 'src/pages/Tenant.vue'
import Contracts from 'src/pages/Contracts.vue'
import Payments from 'src/pages/Payments.vue'
import Collection from 'src/pages/Collection.vue'
import Report from 'src/pages/Report.vue'
import House_Owner_Report from 'src/pages/House_Owner_Report.vue'
import Owner from 'src/pages/Owner.vue'
import Ownership from 'src/pages/Ownership.vue'
import MeterConfig from 'src/pages/MeterConfig.vue'

// Super pages
import SuperOverview from 'src/pages/SuperPages/Overview.vue'
import SuperUser from 'src/pages/SuperPages/User.vue'
import SuperBuilding from 'src/pages/SuperPages/Building.vue'
import SuperHouse from 'src/pages/SuperPages/House.vue'
import SuperTenant from 'src/pages/SuperPages/Tenant.vue'
import SuperContract from 'src/pages/SuperPages/Contract.vue'
import SuperPayment from 'src/pages/SuperPages/Payment.vue'
import SuperAuditLogs from 'src/pages/SuperPages/AuditLogs.vue'

function guardMyroute(to, from, next)
{
 var isAuthenticated= false;
if(sessionStorage.getItem('access_token'))
  isAuthenticated = true;
 else
  isAuthenticated= false;
 if(isAuthenticated) 
 {
  next(); // allow to enter route
 } 
 else
 {
  next('/'); // go to '/login';
 }
}

const moduleRouteMap = {
  'OverviewSuper':  '/dashboard/super/overview',
  'UserSuper':      '/dashboard/super/user',
  'BuildingSuper':  '/dashboard/super/building',
  'HouseSuper':     '/dashboard/super/house',
  'TenantSuper':    '/dashboard/super/tenant',
  'ContractSuper':  '/dashboard/super/contract',
  'PaymentSuper':   '/dashboard/super/payment',
  'AuditLogs_Super':'/dashboard/super/audit-logs',
  'User':           '/dashboard/user',
  'Building':       '/dashboard/building',
  'House':          '/dashboard/house',
  'Tenant':         '/dashboard/tenant',
  'Owner':          '/dashboard/owner',
  'Ownership':      '/dashboard/ownership',
  'Contract':       '/dashboard/contracts',
  'Payment':        '/dashboard/payments',
  'Collection':     '/dashboard/collection',
  'Report':         '/dashboard/report',
  'House_Owner_Report': '/dashboard/house/owner/report',
  'MeterConfig':    '/dashboard/meter-config',
  'Accounts':       '/dashboard/accounts',
};

function getFirstModuleRoute() {
  const modules = (sessionStorage.getItem('modules') || '').split(',');
  for (const mod of modules) {
    if (moduleRouteMap[mod.trim()]) return moduleRouteMap[mod.trim()];
  }
  return null;
}


const routes = [
  {
    path: '/',
    name: 'Login',
    component: Login
  },
  {
    path: '/changePassword',
    name: 'ChangePassword',
    component: ChangePassword
  },
  {
    path: '/forgotPassword',
    name: 'ForgotPassword',
    component: ForgotPassword
  },
  {
  path: '/dashboard',
  component: DashboardLayout,
  redirect: () => {
    const modules = (sessionStorage.getItem('modules') || '').split(',');
    if (modules.includes('OverviewSuper')) return '/dashboard/super/overview';
    return getFirstModuleRoute() || '/dashboard/overview';
  },
  children: [
      {
        path: 'overview',
        name: 'Overview',
        beforeEnter: (to, from, next) => {
          guardMyroute(to, from, (arg) => {
            if (arg !== undefined) return next(arg);
            const modules = (sessionStorage.getItem('modules') || '').split(',');
            if (modules.includes('OverviewSuper')) return next('/dashboard/super/overview');
            // ADMIN/SUPER_ADMIN without OverviewSuper: redirect to first available module
            const role = sessionStorage.getItem('mainRole');
            if (role === 'ADMIN' || role === 'SUPER_ADMIN') {
              const first = getFirstModuleRoute();
              if (first && first !== '/dashboard/overview') return next(first);
            }
            next();
          });
        },
        component: Overview
      },
      {
        path: 'user',
        name: 'User',
        beforeEnter: guardMyroute,
        component: UserProfile
      },
      {
        path: 'accounts',
        name: 'Accounts',
        beforeEnter: guardMyroute,
        component: Accounts
      },
      {
        path: 'building',
        name: 'Building',
        beforeEnter: guardMyroute,
        component: Building
      },
      {
        path: 'tenant',
        name: 'Tenant',
        beforeEnter: guardMyroute,
        component: Tenant
      },
      {
        path: 'owner',
        name: 'Owner',
        beforeEnter: guardMyroute,
        component: Owner
      },
      {
        path: 'ownership',
        name: 'Ownership',
        beforeEnter: guardMyroute,
        component: Ownership
      },
      {
        path: 'house',
        name: 'House',
        beforeEnter: guardMyroute,
        component: House
      },
      {
        path: 'contracts',
        name: 'Contracts',
        beforeEnter: guardMyroute,
        component: Contracts
      },
      {
        path: 'payments',
        name: 'Payments',
        component: Payments
      },
      {
        path: 'collection',
        name: 'Collection',
        component: Collection
      },
      {
        path: 'report',
        name: 'Report',
        component: Report
      },
      {
        path: 'house/owner/report',
        name: 'House_Owner_Report',
        component: House_Owner_Report
      },
      {
        path: 'meter-config',
        name: 'MeterConfig',
        beforeEnter: guardMyroute,
        component: MeterConfig
      },
      {
        path: 'super/overview',
        name: 'SuperOverview',
        beforeEnter: guardMyroute,
        component: SuperOverview
      },
      {
        path: 'super/user',
        name: 'SuperUser',
        beforeEnter: guardMyroute,
        component: SuperUser
      },
      {
        path: 'super/building',
        name: 'SuperBuilding',
        beforeEnter: guardMyroute,
        component: SuperBuilding
      },
      {
        path: 'super/house',
        name: 'SuperHouse',
        beforeEnter: guardMyroute,
        component: SuperHouse
      },
      {
        path: 'super/tenant',
        name: 'SuperTenant',
        beforeEnter: guardMyroute,
        component: SuperTenant
      },
      {
        path: 'super/contract',
        name: 'SuperContract',
        beforeEnter: guardMyroute,
        component: SuperContract
      },
      {
        path: 'super/payment',
        name: 'SuperPayment',
        beforeEnter: guardMyroute,
        component: SuperPayment
      },
      {
        path: 'super/audit-logs',
        name: 'SuperAuditLogs',
        beforeEnter: guardMyroute,
        component: SuperAuditLogs
      },
      {
        path: 'table-list',
        name: 'Table List',
        beforeEnter: guardMyroute,
        component: TableList
      },
      {
        path: 'notifications',
        name: 'Notifications',
        beforeEnter: guardMyroute,
        component: Notifications
      },
    ]
  },
  { path: '*', component: NotFound }
]

/**
 * Asynchronously load view (Webpack Lazy loading compatible)
 * The specified component must be inside the Views folder
 * @param  {string} name  the filename (basename) of the view to load.
function view(name) {
   var res= require('../components/Dashboard/Views/' + name + '.vue');
   return res;
};**/
Vue.use(Router);

const router = new Router({
  mode: 'history',
  routes
});

// Navigation guard - only check authentication
router.beforeEach((to, from, next) => {
  next();
});

export default router;
